/** Strings for creating a topic and its settings (S9, K3). */
export type RejectedWrites = 'rename' | 'membership' | 'both'

const rejectedSubject: Record<RejectedWrites, string> = {
  rename: 'Rename',
  membership: 'Membership update',
  both: 'Rename and membership update',
}

export const topicsCopy = {
  newTopic: 'New topic',
  newTopicDescription:
    'A topic is a long-lived thread where you and your agents work.',
  refreshTopicFailed: 'Could not refresh this topic.',
  refreshAgentsFailed: 'Could not refresh workspace agents.',
  agentsLocked: 'Locked until the agent list reloads.',
  retry: 'Retry',
  retryTopic: 'Retry topic',
  retryAgents: 'Retry agents',
  primaryHelp: 'Receives unaddressed messages in this topic.',
  createFailed: 'Failed to create topic — check the name and try again.',
  deleteFailed: 'Failed to delete topic — try again.',
  workspaceCrumb: 'Workspace',
  agentPaused: 'paused',
  nameLabel: 'Name',
  requiredHint: '(required)',
  nameEmpty: 'Enter a topic name.',
  nameTooLong: 'Use 200 characters or fewer.',
  primaryLabel: 'Primary agent',
  cancel: 'Cancel',
  newTopicPage: {
    nameTaken: 'A topic with this name already exists — choose another name.',
    matchingTopic:
      'A topic with this name already exists — open it from the topic list.',
    unconfirmed:
      'Could not confirm the topic was created — check the topic list.',
    agentsLoadFailed: 'Could not load agents.',
    agentsLegend: 'Agents',
    agentsEmpty: 'This workspace has no agents yet.',
    primaryOptional: '(optional)',
    primaryAuto: 'Choose automatically',
    openTopic: 'Open topic',
    create: 'Create topic',
  },
  settings: {
    title: 'Topic settings',
    description: 'Rename this topic or change its assigned agents.',
    topicCrumb: 'Topic',
    settingsCrumb: 'Settings',
    requestFailed: 'Request failed — try again.',
    notSent: 'not sent',
    confirmedSuccess: 'confirmed success',
    confirmedRejection: 'confirmed rejection',
    statusUnknown: 'status unknown',
    renameOutcome: (outcome: string) => `Rename: ${outcome}`,
    membershipOutcome: (outcome: string) => `Membership: ${outcome}`,
    rejected: (which: RejectedWrites, reloaded: boolean) =>
      reloaded
        ? `${rejectedSubject[which]} rejected — review the current topic and save again.`
        : `${rejectedSubject[which]} rejected and the topic could not be reloaded — reload the page and save again.`,
    outcomeUnknown: 'Could not confirm whether the save succeeded.',
    setPrimaryFailed: 'Failed to set the primary agent — try again.',
    loadFailed: 'Could not load this topic.',
    agentsLoadFailed: 'Could not load workspace agents.',
    agentsLegend: 'Assigned agents',
    agentsEmpty: 'This workspace has no agents.',
    currentPrimary: (name: string) => `Current primary: ${name}`,
    primaryNone: 'None',
    reconciliation: 'Request reconciliation',
    retryRequests: 'Retry requests',
    save: 'Save changes',
    delete: 'Delete topic',
    deleteTitle: 'Delete topic',
    deleteDescription: 'Permanently deletes the topic and its messages.',
    deleteConfirm: 'Delete',
  },
} as const
